import { render, staticRenderFns } from "./FeeModal.vue?vue&type=template&id=34b9467e&"
import script from "./FeeModal.vue?vue&type=script&lang=ts&"
export * from "./FeeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports